import { render, staticRenderFns } from "./YouTubeContent.vue?vue&type=template&id=439a70a6&scoped=true&"
import script from "./YouTubeContent.vue?vue&type=script&lang=js&"
export * from "./YouTubeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a70a6",
  null
  
)

export default component.exports